import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import taskService from '../../services/taskService';
import { toast } from 'react-hot-toast';

const ProjectDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [project, setProject] = useState(null);
  const [files, setFiles] = useState([]);
  const [uploading, setUploading] = useState(false);

  const load = async () => {
    try {
      const projectsRes = await taskService.listProjects();
      const p = (projectsRes.data?.projects || projectsRes.projects || []).find(x => String(x.id) === String(id));
      setProject(p || null);
      const filesRes = await taskService.listProjectFiles(id);
      setFiles(filesRes.data?.files || filesRes.files || []);
    } catch (e) { console.error(e); toast.error('Failed to load project'); }
  };

  useEffect(() => { load(); }, [id]);

  const upload = async (e) => {
    const file = e.target.files?.[0]; if (!file) return;
    try { setUploading(true); await taskService.uploadProjectFile(id, file); toast.success('File uploaded'); load(); }
    catch (err) { toast.error('Upload failed'); }
    finally { setUploading(false); }
  };

  if (!project) return (
    <div className="p-6">
      <button className="text-blue-600" onClick={() => navigate('/projects')}>{'<'} Back</button>
      <div className="mt-4">Loading...</div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-6xl mx-auto space-y-6">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <button className="text-blue-600" onClick={() => navigate('/projects')}>{'<'} Back</button>
          <h1 className="text-2xl font-bold text-gray-900 mt-2">{project.name}</h1>
          <p className="text-gray-600">{project.description || 'No description'}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <h2 className="text-lg font-semibold mb-3">Members</h2>
            <div className="space-y-1">
              {(project.Members || []).map(m => (
                <div key={m.id} className="text-sm">{m.User?.firstName} {m.User?.lastName} • {m.role}</div>
              ))}
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold mb-3">Files</h2>
              <label className="text-sm px-3 py-1 bg-indigo-600 text-white rounded cursor-pointer">
                {uploading ? 'Uploading…' : 'Upload File'}
                <input type="file" className="hidden" onChange={upload} disabled={uploading} />
              </label>
            </div>
            <div className="space-y-1">
              {files.map(f => (
                <a key={f.id} href={f.fileUrl} target="_blank" rel="noreferrer" className="block text-sm text-blue-600 hover:underline">{f.fileName}</a>
              ))}
              {files.length === 0 && <div className="text-sm text-gray-500">No files yet</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDetail;










